import React, { useState } from "react";

import "../css/LynxStyle.css";

const TIP_PRESETS = [10, 15, 20];

const TipCalculator = () => {
  const [bill, setBill] = useState("");
  const [tipPercent, setTipPercent] = useState(15);
  const [people, setPeople] = useState(1);
  const [result, setResult] = useState(null);

  const CalculateTip = () => {
    const billAmount = Number(bill);
    const numPeople = Number(people) || 1;
    if (!billAmount || billAmount <= 0) {
      return;
    }
    const tipAmount = billAmount * (Number(tipPercent) / 100);
    const total = billAmount + tipAmount;

    setResult({
      tipAmount: tipAmount.toFixed(2),
      total: total.toFixed(2),
      perPerson: (total / numPeople).toFixed(2),
    });
  };

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">🧾 Tip Calculator</h3>
      <div className="lynx-page-card">
        <form>
          <div className="form-group">
            <label htmlFor="bill" className="text-white">
              Bill Amount (R):
            </label>
            <input
              type="number"
              value={bill}
              onChange={(e) => setBill(e.target.value)}
              className="form-control"
              id="bill"
              placeholder="Enter bill amount"
            />
          </div>
          <div className="form-group mt-3">
            <label className="text-white">Tip Percentage:</label>
            <div className="d-flex gap-2 flex-wrap mt-1">
              {TIP_PRESETS.map((preset) => (
                <button
                  type="button"
                  key={preset}
                  onClick={() => setTipPercent(preset)}
                  className={
                    Number(tipPercent) === preset
                      ? "btn-lynx"
                      : "btn btn-outline-light"
                  }
                >
                  {preset}%
                </button>
              ))}
              <input
                type="number"
                value={tipPercent}
                onChange={(e) => setTipPercent(e.target.value)}
                className="form-control"
                style={{ maxWidth: "100px" }}
                placeholder="Custom %"
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <label htmlFor="people" className="text-white">
              Split Between (people):
            </label>
            <input
              type="number"
              min="1"
              value={people}
              onChange={(e) => setPeople(e.target.value)}
              className="form-control"
              id="people"
            />
          </div>
          <div className="text-center mt-3">
            <button
              type="button"
              onClick={CalculateTip}
              className="btn-lynx w-100"
            >
              💰 Calculate
            </button>
          </div>
        </form>
        {result && (
          <div className="smsgpt text-center mt-3 fs-5">
            Tip: R{result.tipAmount} &nbsp;|&nbsp; Total: R{result.total}
            <br />
            <small>R{result.perPerson} per person</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default TipCalculator;
